import { MyAccountTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const MyAccountTrackingSchema: Record<MyAccountTrackingPoint, string> = {
  [MyAccountTrackingPoint.PageView]: '8dc35f5b-01dd-4f93-ab21-2c537d87ff89',
  [MyAccountTrackingPoint.ChangePasswordButtonClick]: '',
  [MyAccountTrackingPoint.BackButtonClick]:
    '5ea80fcb-df4b-4120-a6de-520b364b3bcd',
  [MyAccountTrackingPoint.PhoneInfoButtonClick]:
    '1d447f8d-4034-42b7-b4b4-ece07d6777de',
  [MyAccountTrackingPoint.EmailInfoButtonClick]:
    'a70adcaf-c49f-4c18-a119-ad5b48b9e0bb',
  [MyAccountTrackingPoint.LogoutButtonClick]:
    '00f75d05-74d5-4f6c-8d8e-13b8403c41d8',
  [MyAccountTrackingPoint.LogoutPopupImpression]:
    'a0b92b0a-9508-4439-ad2c-06093de4d304',
  [MyAccountTrackingPoint.LogoutPopupConfirmButton]:
    'f147a7fd-fbfc-4e76-879b-9a24d1c03418',
  [MyAccountTrackingPoint.LogoutPopupCancelButton]:
    'f788ff26-d72b-4790-9399-7aa33defce54',
  [MyAccountTrackingPoint.LinkWithShopeeAccountClick]: '',
  [MyAccountTrackingPoint.LinkToADifferentShopeeAccountClick]: '',
  [MyAccountTrackingPoint.LoginWithPasscodeButtonClick]: '',
  [MyAccountTrackingPoint.ReturnToPartnerAccountButtonClick]: '',
  [MyAccountTrackingPoint.DeleteAccountButtonClick]: '',
  [MyAccountTrackingPoint.QuickLoginToggleClick]:
    '86d64bad-f2d9-42a7-9609-ca789f230b54',
  [MyAccountTrackingPoint.QuickLoginLogoutPopupImpression]:
    'a8ef0083-b0ed-4313-9f5e-9369165619e5',
  [MyAccountTrackingPoint.QuickLoginLogoutConfirmButton]:
    '63ac3806-708c-45a3-bc05-26eb5de31ecc',
  [MyAccountTrackingPoint.QuickLoginLogoutBackButton]:
    'b591b055-ad34-4c51-bc15-392b2b55516e',
};

export const getMyAccountPageTypeAndSchema = (
  trackingPoint: MyAccountTrackingPoint
) => {
  return {
    page_type: PageType.MyAccountPage,
    schema: MyAccountTrackingSchema[trackingPoint],
  };
};
